import { constants, typographyStyles } from "@newsela/angelou";

const { textSObj, textMObj } = typographyStyles;

const uiColors = constants.colors.ui;

export const labelRowCss = (isReply) => ({
  marginTop: isReply ? "12px" : "24px",
  display: "inline-block",
  position: "relative",
  color: uiColors.neutral[700],
  fontWeight: 700,
  ...textSObj,

  span: {
    color: uiColors.neutral[500],
    fontWeight: "400",
  },
});

export const editingAreaCss = (noCommentError, isCommentEditMode) => {
  return {
    ...textMObj,
    color: uiColors.neutral[600],
    width: isCommentEditMode ? "calc(100% - 33px)" : "100%",
    resize: "vertical",
    margin: isCommentEditMode ? "0 0 0 33px" : "8px 0 0",
    padding: "12px 12px 12px 16px",
    border: `1px solid ${uiColors.neutral[400]}`,
    borderColor: noCommentError ? uiColors.red[600] : uiColors.neutral[400],
    borderRadius: "4px",

    "&:focus": {
      borderColor: uiColors.core[700],
      outlineColor: uiColors.core[700],
    },

    "&::placeholder": {
      color: uiColors.neutral[400],
    },
  };
};
